(() => {
  const initialise = (browser) => {
    if (!browser || browser.dataset.soShopBrowserReady === 'true') return;
    browser.dataset.soShopBrowserReady = 'true';

    const input = browser.querySelector('[data-so-shop-filter]');
    const items = [...browser.querySelectorAll('[data-so-shop-item]')];
    const groups = [...browser.querySelectorAll('[data-so-shop-group]')];
    const empty = browser.querySelector('[data-so-shop-empty]');
    if (!input || !items.length) return;

    const applyFilter = () => {
      const query = input.value.trim().toLocaleLowerCase();
      let visibleTotal = 0;

      items.forEach((item) => {
        const label = (item.dataset.soShopItem || item.textContent || '').toLocaleLowerCase();
        const visible = !query || label.includes(query);
        item.hidden = !visible;
        if (visible) visibleTotal += 1;
      });

      groups.forEach((group) => {
        const hasVisibleItem = [...group.querySelectorAll('[data-so-shop-item]')].some((item) => !item.hidden);
        group.hidden = !hasVisibleItem;
        if (query && hasVisibleItem && group.tagName === 'DETAILS') group.open = true;
      });

      if (empty) empty.classList.toggle('is-visible', visibleTotal === 0);
    };

    input.addEventListener('input', applyFilter);
  };

  const initialiseAll = () => {
    document.querySelectorAll('[data-so-shop-browser]').forEach(initialise);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseAll, { once: true });
  } else {
    initialiseAll();
  }

  document.addEventListener('shopify:section:load', initialiseAll);

  const filterFacetValues = (input) => {
    const query = input.value.trim().toLocaleLowerCase();
    const facet = input.closest('.facets__display-vertical, .facets__display, .mobile-facets__submenu');
    if (!facet) return;

    facet.querySelectorAll('.facets__item, .mobile-facets__item').forEach((item, index) => {
      const matches = !query || item.textContent.toLocaleLowerCase().includes(query);
      item.classList.toggle('so-facet-search-hidden', !matches);

      if (query) {
        item.classList.remove('hidden');
      } else if (item.classList.contains('show-more-item') && index >= 10) {
        item.classList.add('hidden');
      }
    });
  };

  document.addEventListener(
    'input',
    (event) => {
      const input = event.target.closest('[data-so-facet-search]');
      if (!input) return;
      event.stopPropagation();
      filterFacetValues(input);
    },
    true,
  );

  document.addEventListener('click', (event) => {
    const preset = event.target.closest('[data-so-price-min][data-so-price-max]');
    if (!preset) return;

    const facet = preset.closest('[data-so-price-facet]');
    if (!facet) return;

    const minimum = facet.querySelector('input[name$=".gte"]');
    const maximum = facet.querySelector('input[name$=".lte"]');
    if (!minimum || !maximum) return;

    event.preventDefault();
    minimum.value = preset.dataset.soPriceMin || '';
    maximum.value = preset.dataset.soPriceMax || '';
    maximum.dispatchEvent(new Event('input', { bubbles: true }));
  });
})();
